export default "__VITE_ASSET__B72WZr0o__"